import '../styles.scss'
import React, { useState } from 'react'
import { Row, Col, Button } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

import RowAdvanced from './RowAdvanced'
import SelectAdvanced from './SelectAdvanced'
import HandleRow from './HandleRow'

const AdvancedFilters = ({ filters, setNoUsersText, removePreview, updateReduxAdvancedFilters, getUsersAdvancedFilters, advancedFilters }) => {
  const colNames = ['type', 'option', 'value']
  const mainOptions = [
    { label: I18n.t('dashboard_all'), value: 'all' },
    { label: I18n.t('dashboard_some'), value: 'some' },
    { label: I18n.t('dashboard_none'), value: 'none' },
  ]
  // Create rows with already chosen advanced filters
  let reduxRows = []

  // next col options
  const getNextColOptions = (colIndex, type, fixed) => {
    if (!fixed) return []
    let options
    if (type !== 'createdAt' && type !== 'updatedAt') {
      if (colIndex === 1) {
        options = [
          { label: `${I18n.t('dashboard_is')}`, value: 'is' },
          { label: `${I18n.t('dashboard_its-not')}`, value: 'isnot' },
        ]
        return options
      }
      if (colIndex === 2) {
        options = filters[type]
          ? filters[type].map((el) => ({
            label: el.label,
            value: el.value,
          }))
          : []
        return options
      }
    }
  }

  const createNewRow = ({ values = [], labels = [], el = {}, firstDefaultOptions = [], colNames = [], fixed = false }) => {
    const row = {
      columns: [],
      key: Math.random().toString(),
    }
    for (let i = 0; i < 3; i++) {
      const col = {
        options: i === 0 ? firstDefaultOptions : getNextColOptions(i, el.type, fixed),
        name: colNames.length ? colNames[i] : Object.keys(el)[i],
        value: values.length ? values[i] : '',
        label: labels.length ? labels[i] : '',
      }
      row.columns.push(col)
    }
    return row
  }

  // show already chosen advanced filters
  if (advancedFilters.filters) {
    advancedFilters.filters.forEach((el) => {
      let label
      if (el.type === 'createdAt' || el.type === 'updatedAt') {
        label = el.value
      } else {
        const filterObj = filters[el.type] ? filters[el.type].find((item) => item.value === el.value) : null
        label = filterObj ? filterObj.label : el.value
      }
      const values = [el.type, el.option, el.value]
      const labels = [I18n.t(`campaigns_${el.type}`), I18n.t(`marketing_advanced_filters_${el.option}`), label]
      const firstDefaultOptions = Object.keys(filters).map((key) => ({ label: I18n.t(`campaigns_${key}`), value: key }))
      const row = createNewRow({ values, labels, el, firstDefaultOptions, fixed: true })
      reduxRows.push(row)
    })
  }

  const [rows, setRows] = useState(reduxRows)

  const handleMainOption = ({ value }) => {
    const advFilters = {
      type: value,
      filters: [...advancedFilters.filters],
    }
    updateReduxAdvancedFilters(advFilters)
  }

  const updateRows = ({ type, option, value, action = null, newValue = null }) => {
    let filters = advancedFilters.filters
    switch (action) {
      case 'remove': {
        let filterToDelete
        if (type === 'createdAt' || type === 'updatedAt') {
          filterToDelete = filters.find((el) => el.type === type && el.option === option)
        } else {
          filterToDelete = filters.find((el) => el.type === type && el.option === option && el.value === value)
        }
        const index = filters.findIndex((el) => el === filterToDelete)
        if (index !== -1) filters.splice(index, 1)
        break
      }
      case 'replace': {
        const filterToReplace = filters.find((el) => el.type === type && el.option === option && el.value === value)
        const index = filters.findIndex((el) => el === filterToReplace)
        const newFilter = {
          type,
          option,
          value: newValue,
        }
        filters.splice(index, 1, newFilter)
        break
      }
      default: {
        filters = filters.concat({
          type,
          option,
          value,
        })
      }
    }
    const mainType = advancedFilters.type && advancedFilters.type.length ? advancedFilters.type : mainOptions[0].value
    updateReduxAdvancedFilters({ type: mainType, filters: filters })
  }

  // add new empty row by clicking on "Add condition"
  const addEmptyRow = () => {
    // check if createdAt and updatedAt already chosen
    let firstColumnOptions

    const countCreatedAt = advancedFilters.filters.filter((obj) => obj.type === 'createdAt').length
    const countUpdatedAt = advancedFilters.filters.filter((obj) => obj.type === 'updatedAt').length

    if (countCreatedAt === 2 || countUpdatedAt === 2) {
      // delete createdAt or updatedAt from firstDefaultOption
      const bothOptionsToRemove = countCreatedAt === 2 && countUpdatedAt === 2
      if (bothOptionsToRemove) {
        firstColumnOptions = getFirstColumnOptions(filters, null, 2)
      } else {
        const optionToRemove = countCreatedAt === 2 ? 'createdAt' : 'updatedAt'
        firstColumnOptions = getFirstColumnOptions(filters, optionToRemove)
      }
    } else {
      firstColumnOptions = Object.keys(filters).map((key) => ({ label: I18n.t(`campaigns_${key}`), value: key }))
    }

    const newRow = createNewRow({ firstDefaultOptions: firstColumnOptions, colNames })
    setRows([...rows, newRow])
  }

  const getFirstColumnOptions = (obj, option = '', count = 0) =>
    count === 2
      ? Object.keys(obj)
        .filter((key) => key !== 'createdAt' && key !== 'updatedAt')
        .map((key) => ({ label: I18n.t(`campaigns_${key}`), value: key }))
      : Object.keys(obj)
        .filter((key) => key !== option)
        .map((key) => ({ label: I18n.t(`campaigns_${key}`), value: key }))

  const removeRow = (rowKey) => {
    setNoUsersText(false)

    const rowToDelete = rows.find((row) => row.key === rowKey)
    const updatedRows = rows.filter((row) => row.key !== rowKey)
    setRows(updatedRows)

    // only update filters if value is not empty
    if (rowToDelete.columns[2].value.length) {
      // updateAdvancedFilters
      const { columns } = rowToDelete
      const data = {
        type: columns[0].value,
        option: columns[1].value,
        value: columns[2].value,
        action: 'remove',
      }
      return updateRows(data)
    }
  }

  const showPreview = () => {
    if (advancedFilters.filters.length) getUsersAdvancedFilters('advanced')
    return
  }

  return (
    <>
      <br />
      <span className='create-advanced-rules'>{I18n.t('marketing_create_advanced_rules')}</span>
      <br />
      <br />
      <Row form className='choose-users'>
        <span className='choose-users-text'>{I18n.t('marketing_advanced_filters_choose_users')}</span>
        <SelectAdvanced
          md='2'
          name='type'
          options={mainOptions}
          onChange={handleMainOption}
          defaultValue={mainOptions.find((elem) => elem.value === advancedFilters.type) || mainOptions[0]}
        />
        <span className='choose-users-text text2'>{I18n.t('marketing_advanced_filters_criteria')}:</span>
        <br />
        <br />
      </Row>

      {rows.length > 0 &&
        rows.map((row, index) => (
          <React.Fragment key={index + 1}>
            <Col md={8}>
              <hr key={Math.random()} className='horizontal-line' />
              <RowAdvanced
                key={index}
                name={index}
                row={row}
                rowIndex={index}
                removeRow={removeRow}
                updateRows={updateRows}
                setNoUsersText={setNoUsersText}
                removePreview={removePreview}
                filters={filters}
                advancedFilters={advancedFilters}
              />
            </Col>
          </React.Fragment>
        ))}
      <Row form>
        <HandleRow
          handleClick={addEmptyRow}
          spanClassName={'add-condition-text'}
          type={'add'}
          text={I18n.t('dashboard_add-condition')}
        />
      </Row>

      <Row>
        <Col className='text-center' style={{ paddingBottom: '15px' }}>
          <Button color='primary' size='lg' onClick={showPreview}>
            {I18n.t('marketing_segment_preview')}
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default AdvancedFilters
